import {DataTablesSchema} from "@commons/mapping/DataTablesSchema";
import {UseQueryOptions} from "@tanstack/react-query/src/types";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {
    DocsParams,
    DocumentoParams,
    getDocsAndBadges,
    listClassiDocs,
    MFilesDocParams
} from "@commons/services/lavoratori/lavoratori.documenti.api";
import {MiniUniversalDoc, UniversalDocRecord} from "@commons/mapping/UniversalDocRecord";
import {IDocsBadges} from "@commons/mapping/DocBadges";
import {MFilesDocClass} from "@commons/mapping/MFilesDocClassRecord";
import axios, {AxiosError, AxiosResponse} from "axios";
import {DocAziendaleRecord} from "@commons/mapping/DocAziendaleRecord";
import {config} from "@commons/config.instance";

const retryPolicy = (failureCount: number, error: Error | AxiosError) => {
    if (error instanceof AxiosError) {
        return !error.response ? true : (error.response.status !== 403 ? true : false);
    } else {
        return failureCount < 3;
    }
}

export function useClassiDocsAltro(params: MFilesDocParams, opt?: UseQueryOptions) {
    return useQuery<MFilesDocClass[], Error>({
        queryKey: ['classiDocs', params],
        queryFn: () => listClassiDocs(params),
        retry: retryPolicy,
    })
}

export interface DataTablesSchemaDoc extends DataTablesSchema<UniversalDocRecord>, IDocsBadges {
}

export function useListDocuments(p: DocumentoParams, opt?: UseQueryOptions) {
    // questo controllo se ho specificato "mode" in "p"...
    if (p.mode && p.mode !== 'DataTables')
        throw Error('mode non è compatibile con l\'hook?')
    // ...oppure aggiungo qui "mode"
    // const params: DocumentoParams = {...p, mode: 'DataTables'};
    const queryKey = ['docsAndRefreshBadges', p.idDip, p.sezione, p.anteprima];    // PASSARE tutti i parametri della query (vedi link!)
    return {
        ...useQuery<DataTablesSchemaDoc, Error>({
            /* // https://tanstack.com/query/v4/docs/react/guides/query-keys#if-your-query-function-depends-on-a-variable-include-it-in-your-query-key
                queryKey: ['docsAndRefreshBadges', p],
                // oppure
            */
            queryKey,
            // queryKey: ['docsAndRefreshBadges', p.idDip],
            queryFn: () => getDocsAndBadges(p),
            retry: (failureCount, error) => {
                // @ts-ignore
                return !(error.response.status === 401);
            },
            enabled: DocsParams.isValid(p),
        }), queryKey
    };
}


// UPLOAD FILE IN SEZIONE "ALTRI DOCUMENTI" http://fpnet.local/Docs2022/doc/m-files/contratto/3562/file?auth_token=9dd394d4f5944199860de54df745ac2e
// http://fpnet.local/Docs2022/doc/m-files/contratto/3562/file?auth_token=9dd394d4f5944199860de54df745ac2e
export function useMutationUploadAltro(idDip: number, params: DocumentoParams) {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse<DocAziendaleRecord>, AxiosError, FormData>({
        mutationFn: (doc) => {
            const url = config.getBaseUrl('Docs') + `/doc/m-files/contratto/${idDip}/file`
            return axios.post(url, doc);
        },
        onSuccess: (result, variables, context) => {

            queryClient.refetchQueries({
                //queryKey: ['docsAndRefreshBadges', params]    // con params aggiorna solo la query relativa ai documenti della sezione corrente (e lavoratore...)
                //queryKey: ['docsAndRefreshBadges'] // senza params aggiorno tutte le query per tutte le sezioni e tutti i lavoratori!!!
                queryKey: ['docsAndRefreshBadges', params.idDip]
            })

            //toast('Pubblicazione eseguita correttamente!', {type: 'success'});
        },
        onError: (error, variables, context) => {
            // todo da rivedere!!!
            /*
            if (error.response?.status === 403)
                toastAsError(error.response.data as string);
            if (error.response?.status === 500) { // @ts-ignore
                toastAsError(error.response.data.message);
            }*/
        },
    })
}

// PER IMPOSTARE MASSIVAMENTE LA DT_LETTURA that.config.host + that.config.rootDoc + '/doc/m-files/contratto/:idDip/file-ex/segna-come-letti'
export function useMutationSetDtLetturaMassiva(p: DocumentoParams, onSuccess: () => void) {
    return useMutation<AxiosResponse<Blob>, AxiosError, MiniUniversalDoc[]>({
        mutationFn: (docs) => {
            const url = config.getBaseUrl('Docs') + `/doc/m-files/contratto/${p.idDip}/file-ex/segna-come-letti`
            return axios.post(url, docs);
        },
        onSuccess: (result, variables, context) => {
            onSuccess();
            //toast('Data lettura impostata correttamente!', {type: 'success'});
        },
        onError: (error, variables, context) => {
            // @ts-ignore
            // todo da rivedere!!!
            //toastAsError('Errore in aggiornamento data lettura! ' + error.response.data.message);
        },
    })
}